export { default } from "./KeyStageKeypad";
